import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dashcube': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M326.6 104H110.4C59.3 104 19.2 147.3 19.2 197.5V427C19.2 477.5 59.3 512 110.4 512H337.6C388.7 512 428.8 477.5 428.8 427V0L326.6 104zM153.9 416.5C136.2 416.5 121.5 401.4 121.5 383.7V240.8C121.5 223.1 136.2 208.3 153.9 208.3H294.6C312.3 208.3 326.6 223.1 326.6 240.8V364.3L377.7 416.6H153.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/dashcube.js
// module id = mFBj
// module chunks = 144